import React from 'react';
import { FiCircle, FiX } from 'react-icons/fi';

const AppliedFilters = ({
  search,
  setSearch,
  setShowSearch,
  selectedMainCategory,
  setSelectedMainCategory,
  categories,
  selectedSubItem,
  setSelectedSubItem,
  categoryItems,
  priceRange,
  setPriceRange,
  formatPrice,
  selectedColors,
  toggleFilterSelection,
  selectedMaterials,
}) => {
  return (
    <div className="flex flex-wrap gap-2 mb-4">
      {search && (
        <div className="flex items-center bg-gray-100 px-3 py-1 rounded-full text-sm">
          Search: "{search}"
          <button
            onClick={() => {
              setSearch('');
              setShowSearch(false);
            }}
            className="ml-2 text-gray-500 hover:text-black"
          >
            <FiX size={14} />
          </button>
        </div>
      )}

      {selectedMainCategory && (
        <div className="flex items-center bg-gray-100 px-3 py-1 rounded-full text-sm">
          Category: {categories.find((c) => c._id === selectedMainCategory)?.name}
          <button
            onClick={() => setSelectedMainCategory('')}
            className="ml-2 text-gray-500 hover:text-black"
          >
            <FiX size={14} />
          </button>
        </div>
      )}

      {selectedSubItem && (
        <div className="flex items-center bg-gray-100 px-3 py-1 rounded-full text-sm">
          Type: {categoryItems.find((i) => i._id === selectedSubItem)?.name}
          <button
            onClick={() => setSelectedSubItem('')}
            className="ml-2 text-gray-500 hover:text-black"
          >
            <FiX size={14} />
          </button>
        </div>
      )}

      {(priceRange[0] > 0 || priceRange[1] < 10000) && (
        <div className="flex items-center bg-gray-100 px-3 py-1 rounded-full text-sm">
          Price: {formatPrice(priceRange[0])} - {formatPrice(priceRange[1])}
          <button
            onClick={() => setPriceRange([0, 10000])}
            className="ml-2 text-gray-500 hover:text-black"
          >
            <FiX size={14} />
          </button>
        </div>
      )}

      {selectedColors.map((color) => (
        <div
          key={color}
          className="flex items-center bg-gray-100 px-3 py-1 rounded-full text-sm"
        >
          <FiCircle
            className="w-3 h-3 mr-1"
            style={{ color: color.toLowerCase() }}
          />
          {color}
          <button
            onClick={() => toggleFilterSelection('color', color)}
            className="ml-2 text-gray-500 hover:text-black"
          >
            <FiX size={14} />
          </button>
        </div>
      ))}

      {selectedMaterials.map((material) => (
        <div
          key={material}
          className="flex items-center bg-gray-100 px-3 py-1 rounded-full text-sm"
        >
          {material}
          <button
            onClick={() => toggleFilterSelection('material', material)}
            className="ml-2 text-gray-500 hover:text-black"
          >
            <FiX size={14} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default AppliedFilters;